import type { DateTimeFormats } from '@intlify/core-base';
import datetimeFormats from './dateTime';

const config: { datetimeFormats: DateTimeFormats; fallbackLocale: 'en' } = {
	datetimeFormats,
	fallbackLocale: 'en',
};

export default defineI18nConfig(() => config);
